/** Portal / platform roots that are not a game wiki alias. */
const RESERVED_ROOTS = new Set([
  'profile',
  'wikis',
  'updates',
  'characters',
  'api',
  'heroes',
  '_next',
  'vendor',
  'assets',
  'legacy-game-wiki',
]);

/**
 * Resolve the personal-center URL for the current wiki context.
 * On a game page (`/{alias}/...`) → `/{alias}/profile`.
 * On portal / bare `/profile` → `/profile`.
 */
export function wikiProfilePath(
  gameDomain?: string | null,
  section?: string,
): string {
  const query = section ? `?section=${encodeURIComponent(section)}` : '';
  const fromProp = gameDomain?.trim().replace(/^\/+|\/+$/g, '') || '';
  if (fromProp && !RESERVED_ROOTS.has(fromProp)) {
    return `/${fromProp}/profile${query}`;
  }
  if (typeof window !== 'undefined') {
    const [first] = window.location.pathname.split('/').filter(Boolean);
    if (first && !RESERVED_ROOTS.has(first)) {
      return `/${first}/profile${query}`;
    }
  }
  return `/profile${query}`;
}
